import { render, staticRenderFns } from "./postPreviewBody.vue?vue&type=template&id=69653bd0&"
import script from "./postPreviewBody.vue?vue&type=script&lang=js&"
export * from "./postPreviewBody.vue?vue&type=script&lang=js&"
import style0 from "./postPreviewBody.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports